/**
 * Lightweight analytics for the PWA — sends events to /api/track/event
 * and is ready to plug in GA4 / Microsoft Clarity when keys are provided.
 */
import api from './api';

const GA4_ID = process.env.REACT_APP_GA4_MEASUREMENT_ID;
const CLARITY_ID = process.env.REACT_APP_CLARITY_PROJECT_ID;

let initialized = false;

export function initWebAnalytics() {
    if (initialized) return;
    initialized = true;

    // GA4
    if (GA4_ID) {
        const s = document.createElement('script');
        s.async = true;
        s.src = `https://www.googletagmanager.com/gtag/js?id=${GA4_ID}`;
        document.head.appendChild(s);
        window.dataLayer = window.dataLayer || [];
        window.gtag = function () { window.dataLayer.push(arguments); };
        window.gtag('js', new Date());
        window.gtag('config', GA4_ID);
    }

    // Microsoft Clarity
    if (CLARITY_ID) {
        (function (c, l, a, r, i, t, y) {
            c[a] = c[a] || function () { (c[a].q = c[a].q || []).push(arguments); };
            t = l.createElement(r); t.async = 1; t.src = "https://www.clarity.ms/tag/" + i;
            y = l.getElementsByTagName(r)[0]; y.parentNode.insertBefore(t, y);
        })(window, document, "clarity", "script", CLARITY_ID);
    }
}

export function track(event, properties = {}) {
    // GA4
    if (window.gtag) {
        try { window.gtag('event', event, properties); } catch {}
    }
    // Backend (always — drives /admin/events)
    api.post('/track/event', { event, properties }).catch(() => {});
}

export function identify(userId, traits = {}) {
    if (window.gtag) {
        try { window.gtag('set', 'user_properties', { user_id: userId, ...traits }); } catch {}
    }
    if (window.clarity) {
        try { window.clarity('identify', userId); } catch {}
    }
}
